import { render, staticRenderFns } from "./CompetitionSideBar.vue?vue&type=template&id=13dc35e3&scoped=true"
import script from "./CompetitionSideBar.vue?vue&type=script&lang=ts"
export * from "./CompetitionSideBar.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionSideBar.vue?vue&type=style&index=0&id=13dc35e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc35e3",
  null
  
)

export default component.exports